<template>
  <div class="reset-password">
    <div class="reset-password__container">
      <b-card>
        <div v-if="isLoading && !isVerified">
          <div class="d-flex flex-column">
            <span class="loading-title">Loading...</span>
            <sipnner />
          </div>
        </div>
        <template v-if="!isLoading && !isVerified">
          <div class="logo-wrapper">
            <img :src="logo" alt="" />
          </div>
          <h5 class="mb-5 text-center text-white font-bold">Reset Password</h5>
          <div class="error-message">
            Your email to reset your password has expired.
          </div>
          <div class="sub-text">
            Please click
            <router-link to="/forgotPassword" class="forgot-link">
              here
            </router-link>
            to send email again.
          </div>
        </template>
        <template v-if="isVerified">
          <div class="logo-wrapper">
            <img :src="logo" alt="" />
          </div>
          <h5 class="mb-5 text-center text-white font-bold">Reset Password</h5>
          <b-form class="text-center">
            <b-form-group
              class="text-left input-wrapper"
              :state="passwordState"
              invalid-feedback="Your password must have ateast 8 characters."
            >
              <label for="password">New Password</label>
              <b-form-input
                id="password"
                v-model="formData.password"
                :state="passwordState"
                placeholder="Password"
                trim
                type="password"
                required
                autocomplete="off"
              />
            </b-form-group>
            <b-form-group
              class="text-left input-wrapper"
              :state="confirmPasswordState"
              invalid-feedback="Your passwords do not match."
            >
              <label for="password">Confirm New Password</label>
              <b-form-input
                id="confirmpassword"
                v-model="formData.confirmPassword"
                :state="confirmPasswordState"
                placeholder="Confirm password"
                trim
                type="password"
                required
                autocomplete="off"
              />
            </b-form-group>
            <div class="text-center">
              <b-btn
                class="btn-yellow"
                @click.prevent="submit"
                :disabled="loading"
              >
                {{ buttonCaption }}
              </b-btn>
            </div>
          </b-form>
        </template>
      </b-card>
    </div>
  </div>
</template>
<script>
import Sipnner from "../components/Spinner.vue";
import { AuthService } from "../data/services/auth.service";
import appLogo from "@/assets/img/logo.svg";
export default {
  components: { Sipnner },
  data() {
    return {
      isLoading: true,
      isVerified: false,
      logo: appLogo,
      formData: {
        password: "",
        confirmPassword: "",
      },
      loading: false,
      resetSuccess: false,
    };
  },
  computed: {
    token() {
      return this.$route.query.token ? this.$route.query.token : null;
    },
    buttonCaption() {
      return this.loading === true ? "Loading..." : "Save";
    },
    passwordState() {
      return this.formData.password.length < 6 ? false : null;
    },
    confirmPasswordState() {
      return this.formData.confirmPassword === this.formData.password
        ? null
        : false;
    },
  },
  mounted() {
    if (this.token === null) {
      this.$router.push("/login");
    } else {
      this.verifyToken(this.token);
    }
  },
  methods: {
    getAuthService() {
      return new AuthService();
    },
    async verifyToken(token) {
      const response = await this.getAuthService()
        .verifyResetToken({ token })
        .catch((error) => {
          if (error.code === "ERR_BAD_REQUEST") {
            const response = error.response.data;
            console.log(response.message);
            this.isVerified = false;
            return;
          }
        });
      this.isLoading = false;
      if (response === true) {
        this.isVerified = true;
      }
    },
    async submit() {
      if (this.passwordState === false || this.confirmPasswordState === false) {
        return;
      }
      if (this.loading) {
        return;
      }

      this.loading = true;
      await this.getAuthService()
        .resetPassword({ password: this.formData.password, token: this.token })
        .catch((error) => {
          if (error.code === "ERR_BAD_REQUEST") {
            const response = error.response.data;
            return this.$notify({
              type: "error",
              title: "Error",
              text: response.message,
            });
          }
        });

      this.$notify({
        type: "success",
        title: "Success",
        text: "Your password was successfully changed. Please log in.",
      });
      this.loading = false;
      setTimeout(() => {
        this.$router.push("/login");
      }, 2000);
    },
  },
};
</script>
<style lang="scss" scoped>
.reset-password {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: #024089;
  height: 100vh;
  width: 100vw;

  &__container {
    display: flex;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
  }
  .loading-title {
    font-weight: 500;
    font-size: 24px;
    color: #f8f8f8;
    margin-bottom: 20px;
  }

  .card {
    background-color: transparent;
    border-color: transparent;
    color: white;
  }

  .logo-wrapper {
    margin-bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      height: 65px;
      width: 65px;
    }
  }
  .error-message {
    font-weight: 500;
    margin-bottom: 10px;
  }
  .sub-text {
    font-size: 14px;
  }
  .forgot-link {
    color: #f1bc04;
  }
  .input-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    label {
      font-size: 13px;
      font-weight: lighter;
      color: #fff;
      margin-bottom: 0px;
      margin-left: 10px;
    }
    input {
      padding: 8px 10px;
      font-weight: lighter;
      color: #ffffff;
      margin-bottom: 10px;
      background-color: transparent !important;
      border-color: transparent !important;
      border-bottom: 1px solid #ffffff !important;
      outline: none;

      &::placeholder {
        font-weight: lighter;
        font-size: 11px;
        color: lightblue;
      }
      &:focus {
        box-shadow: none !important;
      }
    }
    small {
      color: #a8b0b7;
    }
  }

  .btn-yellow {
    background: #f1bc04;
    border-color: #f1bc04;
    border-radius: 45px;
    color: #000000;
    min-width: 145px;
    height: 40px;
    line-height: 16px;
    font-size: 13px;
    padding: 11px 30px;
  }

  .success-message {
    width: 300px;
    color: #f8f8f8;
  }
}
</style>